import { render } from "./JumpRopeGame.vue?vue&type=template&id=2e6989dc&scoped=true"
import script from "./JumpRopeGame.vue?vue&type=script&lang=js"
export * from "./JumpRopeGame.vue?vue&type=script&lang=js"

import "./JumpRopeGame.vue?vue&type=style&index=0&id=2e6989dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6989dc"]])

export default __exports__